import { render } from "./WalletSetting.vue?vue&type=template&id=32053a31&scoped=true"
import script from "./WalletSetting.vue?vue&type=script&lang=js"
export * from "./WalletSetting.vue?vue&type=script&lang=js"

import "./WalletSetting.vue?vue&type=style&index=0&id=32053a31&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32053a31"]])

export default __exports__